import { render } from "./SiteLinksBlock.vue?vue&type=template&id=2687830c"
import script from "./SiteLinksBlock.vue?vue&type=script&lang=js"
export * from "./SiteLinksBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/SiteLinksBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2687830c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2687830c', __exports__)) {
    api.reload('2687830c', __exports__)
  }
  
  module.hot.accept("./SiteLinksBlock.vue?vue&type=template&id=2687830c", () => {
    api.rerender('2687830c', render)
  })

}


export default __exports__